import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <div className="footer-content">
                <p>מצאי את השמלה המושלמת לכל אירוע.</p>
                <p className="copyright">©avitalG 2025 JustRentIt</p>
            </div>
        </footer>
    );
}

export default Footer;